import { observer } from 'mobx-react-lite'
import type { PersonalTaxRefundMethodSupportingItemViewModel } from '@/features/jobs/details/tax-type/info-gathering/refund-methods/PersonalTaxRefundMethodSupportingItemViewModel'
import type { BusinessTaxRefundMethodSupportingItemViewModel } from '@/features/jobs/details/tax-type/info-gathering/refund-methods/BusinessTaxRefundMethodSupportingItemViewModel'
import { TaxRefundMethodsDialog } from './index'
import { TaxRefundMethodCardListSectionsContainer } from '@/features/jobs/details/tax-type/info-gathering/refund-methods/components/ProvidedTaxRefundMethodCardList/TaxRefundMethodCardListSectionsContainer'
import { TaxRefundMethodEditorDialog } from '@/features/tax-profile/tax-refund-methods/components/TaxRefundMethodEditorDialog'

export interface TaxRefundMethodsDialogContainerProps {
  vm:
    | PersonalTaxRefundMethodSupportingItemViewModel
    | BusinessTaxRefundMethodSupportingItemViewModel
  isDisabled?: boolean
}

/**
 * Container for the tax refund methods dialogs that wires up the view model.
 */
export const TaxRefundMethodsDialogContainer = observer(
  function TaxRefundMethodsDialogContainer({
    vm,
    isDisabled,
  }: TaxRefundMethodsDialogContainerProps) {
    return (
      <>
        <TaxRefundMethodsDialog
          isOpen={vm.taxRefundMethodsDialog.showing}
          onClose={vm.taxRefundMethodsDialog.close}
        >
          <TaxRefundMethodCardListSectionsContainer
            vm={vm}
            isDisabled={isDisabled}
          />
        </TaxRefundMethodsDialog>

        <TaxRefundMethodEditorDialog
          vm={vm.taxRefundMethodEditorVm}
          isDisabled={isDisabled}
        />
      </>
    )
  },
)
